import {NgModule} from '@angular/core';
import {InvalidControlScrollDirective} from './InvalidControlScrollDirective';
import {ApplicationValidatorService} from '../../services/application/application-validator.service';

@NgModule({
  declarations: [InvalidControlScrollDirective],
  imports: [],
  exports: [
    InvalidControlScrollDirective],
  providers: [ApplicationValidatorService]
})
export class InvalidControlScrollModule {
}
